export enum Combinator {
  AND = 'And',
  OR = 'Or',
  NOT = 'Not',
}
